// Spinner.js
import React from 'react';
import './Spinner.css'; // Create this file for CSS styles

const Spinner = () => {
  return (
    <div className="spinner-overlay">
      <div className="spinner"></div>
    </div>
  );
};

export default Spinner;
